/* eslint-disable */
import { lockBody, unlockBody, addToGlobalThisRet, Spoller } from "@plugins";
import jquery from "jquery";

const $ = jquery;

(function (global) {
    const bugIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const ie10 = navigator.appVersion.indexOf("MSIE 10") !== -1;
    const ie9 = navigator.appVersion.indexOf("MSIE 9") !== -1;

    const sidebarConnectionIcons = document.querySelector(".js-sidebar-connection");

    const createElement = function (cls, parent) {
        const obj = document.createElement("div");
        obj.className = cls;
        if (parent) {
            parent.appendChild(obj);
        }
        return obj;
    };

    function Popup() {
        this.tags = {};
        this.tags.popup = createElement(
            `popup${ie10 ? " popup_ie10" : ""}${ie9 ? " popup_ie9" : ""}`,
            document.body,
        );
        this.tags.popup__overlay = createElement("popup__overlay", this.tags.popup);
        this.tags.popup__table = createElement("popup__table", this.tags.popup);
        this.tags.popup__cell = createElement("popup__cell", this.tags.popup__table);
        this.tags.popup__block = createElement("popup__block", this.tags.popup__cell);
        this.tags.popup__ajax = createElement("popup__ajax", this.tags.popup__block);
        this.tags.popup__close = createElement("popup__close", this.tags.popup__block);
        this.tags.popup__change = createElement("popup__change", this.tags.popup__block);

        this.eventsTrigger = "click";

        this.events();
        this.scrollWidth = this.scrollWidthElement();

        this.defaults = {
            clearClose: false,
            bodyHidden: true,
            addClassNamePopup: "",
            closeOverlay: true,
            closeShow: true,
            background: "",
            closeButtons: "",
            offsetY: 0,
            offsetX: 0,
            coordElement: "",
        };
    }

    Popup.prototype = {
        isOpen: false,

        options(opts) {
            this.defaults = this.extend(
                {
                    clearClose: true,
                    bodyHidden: true,
                    addClassNamePopup: "",
                    closeOverlay: true,
                    closeShow: true,
                    background: "",
                    closeButtons: "",
                    offsetY: 0,
                    offsetX: 0,
                    coordElement: "",
                },
                opts,
            );

            if (this.defaults.background) {
                this.tags.popup.style.background = this.defaults.background;
            }

            return this;
        },

        extend(defaults, source) {
            for (const key in source) {
                if (source.hasOwnProperty(key)) {
                    defaults[key] = source[key];
                }
            }

            return defaults;
        },

        addCloseButtons() {
            const obj = this;
            const buttons = this.defaults.closeButtons.split(",");

            buttons.forEach((item, index) => {
                const selectors = document.querySelectorAll(item.replace(/\s+/g, ""));

                Array.prototype.forEach.call(selectors, (element, i) => {
                    element.addEventListener(
                        obj.eventsTrigger,
                        (evt) => {
                            evt.preventDefault();
                            obj.close();

                            return false;
                        },
                        false,
                    );
                });
            });
        },

        coordSet() {
            const obj = this;
            const button = document.querySelector(this.defaults.coordElement);

            if (button) {
                this.coords = button.getBoundingClientRect();

                this.tags.popup__block.style.left = `${
                    (this.defaults.bodyHidden ? 0 : window.pageXOffset) +
                    this.coords.left +
                    this.defaults.offsetX
                }px`;
                this.tags.popup__block.style.top = `${
                    (this.defaults.bodyHidden ? 0 : window.pageYOffset) +
                    this.coords.top +
                    this.defaults.offsetY
                }px`;
                this.tags.popup__block.style.position = "absolute";
            }

            return this;
        },

        coordReset() {
            const obj = this;

            this.defaults = {
                clearClose: true,
                bodyHidden: true,
                addClassNamePopup: "",
                closeOverlay: true,
                closeShow: true,
                background: "",
                closeButtons: "",
                offsetY: 0,
                offsetX: 0,
                coordElement: "",
            };

            setTimeout(() => {
                obj.tags.popup.style.background = "";
            }, 500); // указан в файле стилей transition

            this.tags.popup__block.style.left = "";
            this.tags.popup__block.style.top = "";
            this.tags.popup__block.style.position = "";
            return this;
        },



        setBodyStyle() {
            lockBody(this.tags.popup, {
                reserveScrollBarGap: true,
            });

            if (sidebarConnectionIcons) {
                sidebarConnectionIcons.style.right = "27px";
            }

            return this;
        },

        clearBodyStyle() {
            unlockBody(this.tags.popup);

            if (sidebarConnectionIcons) {
                sidebarConnectionIcons.removeAttribute("style");
            }

            return this;
        },

        html(response, callback) {
            $(this.tags.popup__change).html(response);

            if (callback) {
                callback.call(this.tags.popup, this.defaults, this.eventsTrigger);
            }

            return this;
        },

        append(response, callback) {
            $(this.tags.popup__change).html(response);

            if (callback) {
                callback.call(this.tags.popup, this.defaults, this.eventsTrigger);
            }

            if (this.defaults.closeButtons) {
                this.addCloseButtons();
            }

            return this;
        },

        clear(clear) {
            if (this.defaults.clearClose || clear) {
                this.tags.popup__change.innerHTML = "";
            }
            return this;
        },

        show(callback) {
            if (!this.isOpen) {
                this.setBodyStyle();
            }

            this.offsetTop = window.pageYOffset;

            document.body.style.top = `${this.offsetTop * -1}px`;

            this.isOpen = true;

            this.tags.popup.className = "popup";

            if (bugIOS) {
                document.documentElement.classList.add("popup_iphone");
            }

            if (this.defaults.closeShow) {
                this.tags.popup__close.style.display = "";
            } else {
                this.tags.popup__close.style.display = "none";
            }

            if (this.defaults.coordElement) {
                this.coordSet();
            }

            if (this.defaults.closeButtons) {
                this.addCloseButtons();
            }

            if (this.defaults.addClassNamePopup) {
                this.tags.popup.classList.add(this.defaults.addClassNamePopup);
            }

            this.tags.popup.classList.add("popup_active");

            popapAddFile();

            if (callback) {
                callback.call(this.tags.popup, this.defaults, this.eventsTrigger);
            }

            const popupAccordion = this.tags.popup?.querySelector(".js-popap-accordion");

            if (popupAccordion) {
                new Spoller(".js-popap-accordion", {
                    duration: 250,
                    selectorToggleBtn: ".js-popap-accordion-toggle-btn",
                    selectorContent: ".js-popap-accordion-text",
                    makeToggleBtnActive: false,
                });
            }

            // const selects = [...this.tags.popup?.querySelectorAll(".js-input-select-init")];
            // if (selects && selects.length) globalThis.ret.initInputSelects(selects);

            const selects = [...this.tags.popup?.querySelectorAll("[data-custom-select]")];
            if (selects && selects.length) globalThis.ret.baseSelectsInit(selects);

            return this;
        },

        close(clear, callback) {
            const obj = this;

            setTimeout(() => {
                obj.tags.popup.classList.remove("popup_active");

                if (bugIOS) {
                    document.documentElement.classList.remove("popup_iphone");
                }

                if (obj.defaults.addClassNamePopup) {
                    obj.tags.popup.classList.remove(obj.defaults.addClassNamePopup);
                }

                if (clear == "clear") {
                    obj.tags.popup__change.innerHTML = "";
                }

                obj.coordReset();

                if (callback) {
                    callback.call(obj.tags.popup, obj.defaults, obj.eventsTrigger);
                }

                obj.clearBodyStyle();

                obj.isOpen = false;
                document.body.style.top = "";
                window.scrollTo(0, obj.offsetTop);
            }, 50);

            return this;
        },

        events() {
            const obj = this;

            this.tags.popup__close.addEventListener(
                this.eventsTrigger,
                (e) => {
                    obj.close();
                    return false;
                },
                false,
            );

            this.tags.popup__overlay.addEventListener(
                this.eventsTrigger,
                (e) => {
                    if (obj.defaults.closeOverlay) {
                        obj.close();
                    }

                    return false;
                },
                false,
            );

            document.addEventListener(
                "keydown",
                (e) => {
                    if (e.key === "Escape" || e.key === "Esc") {
                        if (obj.isOpen) {
                            // "Esc": IE/Edge specific value
                            obj.close();
                        }
                    }
                },
                false,
            );
        },

        loader(trigger) {
            trigger
                ? this.tags.popup__ajax.classList.add("show")
                : this.tags.popup__ajax.classList.remove("show");
        },

        scrollWidthElement() {
            const div = document.createElement("div");
            div.style.overflowY = "scroll";
            div.style.width = "50px";
            div.style.height = "50px";
            div.style.visibility = "hidden";

            document.body.appendChild(div);
            const scrollWidth = div.offsetWidth - div.clientWidth;
            document.body.removeChild(div);

            return scrollWidth;
        },
    };

    window.Popup = Popup;
})(window);

function popapAddFile() {
    const inputBlocks = document.querySelectorAll(".js-popup-input-file-inner");

    if (inputBlocks) {
        for (const inputBlock of inputBlocks) {
            const templateFile = inputBlock.querySelector(".js-template-file");
            const templateFileBox = inputBlock.querySelector(".js-popup-input-file-box");
            const inputBtn = inputBlock.querySelector(".js-popup-input-file-btn");
            inputBtn.addEventListener("click", () => {
                const inputDataAttribute = inputBlock.getAttribute("data-type");
                if (inputDataAttribute) {
                    // Проверяем наличие пустых инпутов и удаляем если есть
                    const emptyInput = templateFileBox.querySelector(".popup-input__file-item--hidden");
                    if (emptyInput) {
                        templateFileBox.children[0].remove();
                    }
                    // Проверяем соответствие data-attribute и количества загружаемых файлов
                    if (inputDataAttribute === "image" && templateFileBox.children.length < 10
                        || inputDataAttribute === "video" && templateFileBox.children.length < 1
                    ) {
                        // При клике на кнопку клонируем элемент
                        const clone = templateFile.content.cloneNode(true);
                        templateFileBox.prepend(clone);
                        // После получаем инпут и кнопку для удаления
                        const inputFile = inputBlock.querySelectorAll(".js-popup-file-input");
                        const templateFileBtnRemove = inputBlock.querySelectorAll(".js-popup-input-file-card-remove");
                        // Т.к. выбор файла работает при нажатии на input, то эмулируем клик на первый input в массиве
                        inputFile[0].click();
                        // Слушаем событие у первого input в массиве
                        inputFile[0].addEventListener("change", (e) => {
                            if (e.target.value) {
                                const fileType = e.target.value.split(".").pop();
                                // Защита от тех, кто в проводнике выберет "все файлы"
                                if (inputDataAttribute === "image" && (fileType == "JPG" || fileType == "jpg" || fileType == "JPEG" || fileType == "jpeg")) {
                                    if (e.target.files[0].size < 5242880) {
                                        inputFile[0]
                                            .closest(".js-popup-input-file-item")
                                            .classList.remove("popup-input__file-item--hidden");
                                        let fr = new FileReader();

                                        fr.onload = () => {
                                            inputBlock.querySelector(
                                                ".js-popup-input-file-item-text",
                                            ).style.backgroundImage = "url(" + fr.result + ")";
                                        };
                                        fr.readAsDataURL(e.target.files[0]);
                                    } else {
                                        alert("Загружаемое фото должно быть не больше 5 мб");
                                        // Удаляем пустой клон
                                        templateFileBox.children[0].remove();
                                    }
                                } else if (inputDataAttribute === "video" && (fileType == "MOV" || fileType == "mov" || fileType == "MP4" || fileType == "mp4" || fileType == "AVI" || fileType == "avi")) {
                                    inputFile[0]
                                        .closest(".js-popup-input-file-item")
                                        .classList.remove("popup-input__file-item--hidden");

                                    inputBlock
                                        .querySelector(".js-popup-input-file-video source")
                                        .setAttribute('src', URL.createObjectURL(e.target.files[0]));

                                    const video = document.querySelector(".js-popup-input-file-video");
                                    const canvas = document.querySelector(".js-popup-input-file-canvas");
                                    const canvasImage = canvas.getContext("2d");

                                    video.load();

                                    // Слушаем загрузку metadata у видео
                                    video.addEventListener('loadedmetadata', function() {
                                        canvas.width = video.videoWidth;
                                        canvas.height = video.videoHeight;

                                        if (video.duration < 180) {
                                            video.addEventListener('timeupdate', function() {
                                                canvasImage.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
                                            });
                                        } else {
                                            templateFileBox.children[0].remove();
                                            alert("Длительность видео не должна превышать 3 минуты");
                                        }
                                    });
                                } else {
                                    alert("Загружаемые файлы имеют неподходящий формат");
                                    templateFileBox.children[0].remove();
                                }
                            }
                            setTimeout(() => {
                                for (let i = 0; i < inputFile.length; i++) {
                                    if (inputFile[i].files.length == 0) {
                                        inputFile[i].closest(".js-popup-input-file-item").remove();
                                    }
                                }
                            }, 100);
                        });

                        templateFileBtnRemove.forEach((item) => {
                            item.addEventListener("click", (e) => {
                                e.target.closest(".js-popup-input-file-item").remove();
                            });
                        });
                    } else {
                        alert("Нельзя загрузить больше файлов");
                    }
                }
            });
        }
    }
}

function initFileLoaderProgressBar() {
    //класс формы взял с боя, при необходимости заменить
    const form = document.querySelector(".js-form_doc-all");

    if (form) {
        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener('progress', (e) => {
            const progressbarValue = form.querySelector(".js-progressbar-value");
            const progressbarStrokeValue = form.querySelector(".js-progressbar-stroke-value");
            const abortReviewBtn = form.querySelector(".js-abort-review");

            const percentLoaded = Math.round((e.loaded / e.total) * 100);

            //нужно что бы показать прогрессбар и скрыть кнопку отправки
            form.classList.add("sending");

            if (progressbarValue) {
                progressbarValue.textContent = `${percentLoaded}%`;
            }

            if (progressbarStrokeValue) {
                progressbarStrokeValue.style.strokeDashoffset = (188 - (188 * percentLoaded) / 100);
            }

            if (abortReviewBtn) {
                abortReviewBtn.addEventListener("click", ()=> {
                    xhr.abort();
                    form.classList.remove("sending");

                    // убираю display: none с кнопки отправить при abort
                    const btn = form.querySelector(".js-send-review-product");

                    if (btn) {
                        btn.removeAttribute("style");
                    }
                })
            }
        }, false);

        return xhr;
    }
}

addToGlobalThisRet(initFileLoaderProgressBar, "initFileLoaderProgressBar");
